<template>
  <div id="closableCardBody" class="plainStandardTheme"  :class="!isMobile?'bigRoundAngles bigShadow':''">
    <router-link :to="{name: 'saison'}" v-if="!isMobile" class="close">Retour au site</router-link>
    <h1 class="title" v-if="!isMobile">{{title}}</h1>
    <router-link :to="{name: 'saison'}" v-else class="title">Retour au site</router-link>

    <div class="innerbody" :style="cssProps">
      <slot @quit="set_closableCardOpened(false)"></slot>
    </div>

  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "closableCard",

  props: {
    title: String,
    padding: {
      type: String,
      default: '1vw'
    },
    unclosable: Boolean
  },
  ...mapGetters('show', [
    'currentShow',
  ]),
  created: function () {
    this.set_closableCardOpened(true)
    this.set_carousselNavTo(1)
  },
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'closableCardOpened',
    ]),
    cssProps: function(){
      return {
        '--innerPadding': this.padding
      }
    }
  },
  methods: {
    ...mapActions('global', [
      'set_closableCardOpened',
      'set_carousselNavTo'
    ]),
  }

}
</script>

<style scoped>
#closableCardBody {
  position: relative;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  /*max-width: calc(min(900px, 50vw));*/
  max-width: 100%;
  width: 100%;
  min-width: 56vw;
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;

  align-self: center;
  z-index: 3;
  /*margin-top: 7vw;*/
}
.close {
  position: absolute;
  top: 1vw;
  right: 1vw;
  font-size: 1.5vw;
  cursor: pointer;
  z-index: auto;
}

.title{
  grid-row: 1/2;
  padding: 1vw;
  margin: 0;
}

.innerbody {
  /*margin: 5vw;*/
  grid-row: 2/3;
  overflow: auto;
  width:calc(100% - var(--innerPadding)*2);
  max-width: calc(100% - var(--innerPadding)*2);
  min-width: calc(100% - var(--innerPadding)*2);
  max-height: calc(100% - var(--innerPadding)*2);
  height: 100%;
  padding: var(--innerPadding);
  scrollbar-color: var(--goalBackgroundColor) #bbbbbb !important;
  scrollbar-width: thin !important;
  background-color: hsl(0, 50%, 95%);
  color: #162327;
}

h1 {
  text-align: center;
}

a{
  color: var(--learnColor);
}
img{
  border-radius: 0.5vw;
}
p, ul, li{
  font-size: 0.8vw;
}

@media screen and (max-device-width: 767px) {
  #closableCardBody {
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 100%;
    margin: 0;
  }

  p, ul, li{
    font-size: 3.5vw;
  }

  .close {
    top: 1vw;
    right: 2vw;
    font-size: 6.5vw;
  }
}
</style>